import { PalletDetailDto, PalletEditDto } from './pallet';

export const mapPalletDetailToEdit = (dto: PalletDetailDto): PalletEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  active: dto.active,
  description: dto.description
});
